import * as React from 'react'
import './CookieBanner.css'
import { Icon } from '../Icons/Icon';
import { AdminIcon } from '../Icons/AdminIcon';
import { useNavigate } from 'react-router-dom';

export const CookieBanner = () =>{
    const [isVisible, setIsVisible] = React.useState(false);
     const navigate = useNavigate();

  React.useEffect(() => {
    const hasConsented = localStorage.getItem('cookie-consent');
    if (!hasConsented) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-container">
        <div className="cookie-banner-alignment">
          <div className="cookie-banner-text-container">
            <p className="cookie-banner-text-paragraph">
              Vi använder cookies för att förbättra din upplevelse på vår webbplats. 
              Genom att fortsätta använda sidan godkänner du vår användning av cookies. 
              <span className="cookie-banner-text-paragraph-important" onClick={() => navigate('/privacy-policy')}>
                Läs mer i vår integritetspolicy
              </span>
            </p>
          </div>
          
          <div className="cookie-banner-button-container">
            <button
              onClick={handleDecline}
              className="cookie-banner-button-one"
            >
              Avböj
            </button>
            <button
              onClick={handleAccept}
              className="cookie-banner-button-two"
            >
              Acceptera
            </button>
            <button
              onClick={() => setIsVisible(false)}
              className="cookie-banner-button-three"
              aria-label="Stäng"
            >
                {/* <Icon.CheckMarkCross/> */}
                <AdminIcon.CrossClose height={18} width={18} fill="white"/>
              {/* <X size={18} /> */}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}